
























































































































































































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import CBudgetAgreementModal, { iAgrBtns } from '@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue';
import CBudgetAgreementHistModal from '@/modules/budget-request/components/budget-sum-calc/budget-agreement-hist-modal.vue';
import store from '@/services/store';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    components: {
        'c-budg-agr-modal': CBudgetAgreementModal,
        'c-budg-agr-hist-modal': CBudgetAgreementHistModal,
    },
    name: 'c-calc-gkkp-paid-tab'
})
export default class CBubgGkkpPaidTab extends Vue {
    @Prop({
        required: true,
        default: 0
    })
    private curYearProp!: number;

    @Prop({
        required: true,
        default: null
    })
    private curAbpProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curDataTypeProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private regionProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curVariantProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curSubordProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private curGkkpProp!: any | null;

    @Prop({
        required: true,
        default: null
    })
    private variantEndDateProp!: any | null;

    private readonly modeCode = 'gkkp';
    private operationCode: string[] = []; // операции согласования
    private operationSignCode: string[] = []; // операции подписания (!!пока не нужно)

    private progress = 0;
    private collapseAll = true;
    private calcData: any[] = [];
    private totalSum = { value1: 0, value2: 0, value3: 0, valPaid1: 0, valPaid2: 0, valPaid3: 0, spendSum1: 0, spendSum2: 0, spendSum3: 0 };

    private checkedAll = false;

    // доступность согласования
    private agrEnabled = false;
    private agrBtnLst: iAgrBtns = { back: [], forward: [] };
    private selectArr: any = [];

    private curGkkp: any | null = null;
    private curSubord: any | null = null;
    private curYear: number = 0;
    private curAbp: any = null;
    private curDataType: any = null;
    private curRegion: any = null;
    private curVariant: any = null;
    private variantEndDate: any | null = null;

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    private chgEvent(params: any) {
        this.curAbp = params.curAbp;
        this.curYear = params.curYear;
        this.curDataType = params.curDataType;
        this.curRegion = params.regionProp;
        this.curVariant = params.curVariant;
        this.curSubord = params.curSubord;
        this.curGkkp = params.curGkkp;
        this.variantEndDate = params.variantEndDate;
        this.loadData();
    }

    private mounted() {
        this.curAbp = this.curAbpProp;
        this.curYear = this.curYearProp;
        this.curDataType = this.curDataTypeProp;
        this.curRegion = this.regionProp;
        this.curVariant = this.curVariantProp;
        this.curSubord = this.curSubordProp;
        this.curGkkp = this.curGkkpProp;
        this.variantEndDate = this.variantEndDateProp;
        this.setAgrEnabled();
        this.loadData();
        this.$watch('usrId', () => {
            if (!this.usrId) { return; }
            this.loadOperations();
        });
        this.$watch('curVariant', () => {
            this.setAgrEnabled();
        });
    }

    private async loadData() {
        this.calcData = [];
        this.totalSum = { value1: 0, value2: 0, value3: 0, valPaid1: 0, valPaid2: 0, valPaid3: 0, spendSum1: 0, spendSum2: 0, spendSum3: 0 };
        if (!this.curAbp || !this.curDataType || !this.curYear || !this.curVariant) { return; }
        this.progress = 30;
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = { curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, bin: this.curGkkp ? this.curGkkp.bin: null, usrId: this.usrId, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: versYear, subord: this.curSubord };
        const result = await Promise.all([
            this.loadTotalGkkpPaid(params),
            this.loadTotalAgreement()
        ]);
        if (!result[0]) { return; }

        this.createTableData(result[0], result[1]);
    }

    // ------------------------ получение дерева ------------------
    private createTableData(gkkpPaid: any[], agreementMap: Map<any, any>) {
        const result: any[] = this.createGkkpArr(gkkpPaid);
        for (const elGkkp of result) {
            let flGkkpAgr = false;
            elGkkp.prgLst.sort((a: any, b: any) => (a.prg > b.prg) ? 1 : -1);
            const prgArr: any[] = [];
            for (let i = 0; i < elGkkp.prgLst.length; i++) {
                const elPrg = elGkkp.prgLst[i];
                if (prgArr.length === 0 || prgArr[prgArr.length-1].prg !== elPrg.prg) {
                    this.createPprArr(prgArr, agreementMap.get(elGkkp.bin));
                    if (prgArr.length) { this.calcTotal(elGkkp.totalSum, prgArr[prgArr.length - 1]); }
                    const obj = { prg: elPrg.prg, name_ru: elPrg.prg_name_ru, collapse: this.collapseAll, pprLst: [elPrg], totalSum: { value1: 0, value2: 0, value3: 0, valPaid1: 0, valPaid2: 0, valPaid3: 0, spendSum1: null, spendSum2: null, spendSum3: null } };
                    prgArr.push(obj);
                } else {
                    prgArr[prgArr.length - 1].pprLst.push(elPrg);
                }
                if (i === elGkkp.prgLst.length - 1) {
                    this.createPprArr(prgArr, agreementMap.get(elGkkp.bin));
                    this.calcTotal(elGkkp.totalSum, prgArr[prgArr.length - 1]);
                }
                if (prgArr.length && prgArr[prgArr.length - 1].checked!==undefined) { flGkkpAgr = true; }
            }
            if (flGkkpAgr) { elGkkp.checked = this.checkedAll; }
            elGkkp.prgLst = prgArr;
        }
        this.progress += 10;
        this.totalSum = { value1: 0, value2: 0, value3: 0, valPaid1: 0, valPaid2: 0, valPaid3: 0, spendSum1: 0, spendSum2: 0, spendSum3: 0 };
        for (const el of result) {
            this.calcTotal(this.totalSum, el.totalSum);
            this.calcProc(el.totalSum);
        }
        this.calcProc(this.totalSum);
        this.calcData = result;
        this.progress = 100;
    }


    private calcProc(obj: any) {
        for (let i = 1; i < 4; i++) {
            if (obj[`value${i}`] || obj[`valPaid${i}`]) {
                obj[`spendSum${i}`] = 0;
                if (obj[`value${i}`]) { obj[`spendSum${i}`] += obj[`value${i}`]; }
                if (obj[`valPaid${i}`]) { obj[`spendSum${i}`] += obj[`valPaid${i}`]; }
            }
        }
    }

    private createGkkpArr(arr: any[]) {
        const result: any[] = [];
        for (const el of arr) {
            this.translateKz(el);
            this.getValue(el);
            if (result.length === 0 || result[result.length-1].bin !== el.bin) {
                const obj = { bin: el.bin, name_ru: el.bin_name_ru, collapse: this.collapseAll, prgLst: [el], totalSum: { value1: 0, value2: 0, value3: 0, valPaid1: 0, valPaid2: 0, valPaid3: 0, spendSum1: null, spendSum2: null, spendSum3: null } };
                result.push(obj);
            } else {
                result[result.length-1].prgLst.push(el);
            }
        }
        return result;
    }

    // перевод на казахский
    private translateKz(obj: any) {
        const locale = this.$i18n.locale;
        if (locale !== 'kk') { return; }
        if (obj.bin_name_kk) { obj.bin_name_ru = obj.bin_name_kk; }
        if (obj.prg_name_kk) { obj.prg_name_ru = obj.prg_name_kk; }
        if (obj.ppr_name_kk) { obj.ppr_name_ru = obj.ppr_name_kk; }
        if (obj.spf_name_kk) { obj.spf_name_ru = obj.spf_name_kk; }
    }

    private createPprArr(prgArr: any[], agreementMap: Map<any, any> | null) {
        if (!prgArr.length) { return; }
        const pprArr: any[] = [];
        prgArr[prgArr.length - 1].pprLst.sort((a: any, b: any) => (a.ppr > b.ppr) ? 1 : -1);

        const prgMap = agreementMap? agreementMap.get(prgArr[prgArr.length - 1].prg): null;
        let flProgAgr = false; // true - есть записи с согласованием на уровне подпрограммы
        for (let i = 0; i < prgArr[prgArr.length - 1].pprLst.length; i++) {
            const elPpr = prgArr[prgArr.length - 1].pprLst[i];
            const pprAgr = prgMap? prgMap.get(elPpr.ppr): null;
            let tmpAgr: any | null = null;
            if (pprAgr !== null) {
                pprAgr.status = setNameLang(this.$i18n.locale, pprAgr.status);
                tmpAgr = { id: pprAgr.id, status: pprAgr.status.code, updateDate: pprAgr.update_date, userId: pprAgr.user_id, statusName: pprAgr.status.name, status_lang: {name_ru: pprAgr.status.name_ru, name_kk: pprAgr.status.name_kk, name_en: pprAgr.status.name_en, availableStep: pprAgr.availableStep}, commentTxt: pprAgr.commentTxt, operation_codes: pprAgr.operation_codes };
            }
            if (elPpr.ppr === null && tmpAgr) {
                prgArr[prgArr.length - 1].agrObj = tmpAgr;
                if (pprAgr.availableStep) { prgArr[prgArr.length -1].checked = this.checkedAll; }
            }
            if (pprArr.length === 0 || pprArr[pprArr.length -1].ppr !== elPpr.ppr) {
                this.createSpfArr(pprArr);
                if (pprArr.length) { this.calcTotal(prgArr[prgArr.length - 1].totalSum, pprArr[pprArr.length - 1]); }
                const objPpr: any = { ppr: elPpr.ppr, name_ru: elPpr.ppr_name_ru, collapse: this.collapseAll,  totalSum: { value1: 0, value2: 0, value3: 0, valPaid1: 0, valPaid2: 0, valPaid3: 0, spendSum1: null, spendSum2: null, spendSum3: null }, spfLst: [elPpr] }
                if (elPpr.ppr !== null && tmpAgr) {
                    objPpr.agrObj = tmpAgr;
                    if (pprAgr.availableStep) {
                        objPpr.checked = this.checkedAll;
                        flProgAgr = true;
                    }
                }
                pprArr.push(objPpr);
            } else {
                pprArr[pprArr.length - 1].spfLst.push(elPpr);
            }
            if (i === prgArr[prgArr.length - 1].pprLst.length - 1) {
                this.createSpfArr(pprArr);
                this.calcTotal(prgArr[prgArr.length - 1].totalSum, pprArr[pprArr.length - 1]);
                this.calcProc(prgArr[prgArr.length - 1].totalSum);
            }
        }
        if (flProgAgr) { prgArr[prgArr.length - 1].checked = this.checkedAll; }
        prgArr[prgArr.length - 1].pprLst = pprArr;
    }

    private createSpfArr(pprArr: any[]) {
       if (!pprArr.length || !pprArr[pprArr.length - 1].spfLst.length) { return; }
        pprArr[pprArr.length - 1].spfLst.sort((a: any, b: any) => (a.spf > b.spf) ? 1 : -1);
        const spfArr: any[] = [];
        for (let i = 0; i < pprArr[pprArr.length - 1].spfLst.length; i++) {
            const elSpf = pprArr[pprArr.length - 1].spfLst[i];
            if (spfArr.length === 0 || spfArr[spfArr.length - 1].spf !== elSpf.spf) {
                this.createFormArr(spfArr);
                if (spfArr.length) { this.calcTotal(pprArr[pprArr.length - 1].totalSum, spfArr[spfArr.length - 1]); }
                const spfObj = { spf: elSpf.spf, name_ru: elSpf.spf_name_ru, collapse: this.collapseAll,  totalSum: { value1: 0, value2: 0, value3: 0, valPaid1: 0, valPaid2: 0, valPaid3: 0, spendSum1: null, spendSum2: null, spendSum3: null }, formLst: [elSpf] };
                spfArr.push(spfObj);
            } else {
                spfArr[spfArr.length - 1].formLst.push(elSpf);
            }
            if (i === pprArr[pprArr.length - 1].spfLst.length - 1) {
                this.createFormArr(spfArr);
                this.calcTotal(pprArr[pprArr.length - 1].totalSum, spfArr[spfArr.length - 1]);
                this.calcProc(pprArr[pprArr.length - 1].totalSum);
            }
        }
        pprArr[pprArr.length - 1].spfLst = spfArr;
    }

    private createFormArr(spfArr: any[]) {
       if (!spfArr.length || !spfArr[spfArr.length - 1].formLst.length) { return; }
        spfArr[spfArr.length - 1].formLst.sort((a: any, b: any) => (a.form > b.form) ? 1 : -1);
        const formArr: any[] = [];
        for (let i = 0; i < spfArr[spfArr.length - 1].formLst.length; i++) {
            const elForm  = spfArr[spfArr.length - 1].formLst[i];
            if (formArr.length === 0 || formArr[formArr.length - 1].form !== elForm.form) {
                if (formArr.length) { this.calcTotal(spfArr[spfArr.length - 1].totalSum, formArr[formArr.length - 1]); }
                const formObj = { value1: null, value2: null, value3: null, valPaid1: null, valPaid2: null, valPaid3: null, spendSum1: null, spendSum2: null, spendSum3: null, form: elForm.form, urlLink1: null, urlLink2: null, urlLink3: null };
                this.setValue(formObj, elForm);
                formArr.push(formObj);
            } else {
                this.setValue(formArr[formArr.length - 1], elForm);
            }
            this.calcProc(formArr[formArr.length - 1]);
            if (i === spfArr[spfArr.length - 1].formLst.length-1) {
                this.calcTotal(spfArr[spfArr.length - 1].totalSum, formArr[formArr.length - 1]);
                this.calcProc(spfArr[spfArr.length - 1].totalSum);
            }
        }
        spfArr[spfArr.length - 1].formLst = formArr;
    }

    private calcTotal(savedObj: any, childObj: any) {
        for (let i = 1; i < 4; i++) {
            if (childObj.totalSum) {
                if (childObj.totalSum[`value${i}`]) { savedObj[`value${i}`] += childObj.totalSum[`value${i}`]; }
                if (childObj.totalSum[`valPaid${i}`]) { savedObj[`valPaid${i}`] += childObj.totalSum[`valPaid${i}`]; }
            }
            if (childObj[`value${i}`]) { savedObj[`value${i}`] += childObj[`value${i}`]; }
            if (childObj[`valPaid${i}`]) { savedObj[`valPaid${i}`] += childObj[`valPaid${i}`]; }
        }
    }

    private setValue(formObj: any, el: any) {
        for (let i = 1; i < 4; i++) {
            if (el[`value${i}`]) {
                formObj[`value${i}`] = el[`value${i}`];
                formObj[`source_link${i}`] = el[`source_link${i}`];
                if (el[`source_link${i}`]) {
                    formObj[`urlLink${i}`] = `#/${el[`source_link${i}`]}`;
                } else {
                    const href = encodeURI(`#/form${el.form}/${this.curYear}/${el.year}/${el.data_type}/${el.gr}/${el.abp}/${el.prg}/${el.ppr}/false/${el.variant}/${el.spf}/${el.bin}/gkkp/true/end`)
                    formObj[`urlLink${i}`] = href;
                }
            }
            if (el[`valPaid${i}`]) {
                formObj[`valPaid${i}`] = el[`valPaid${i}`];
                formObj[`source_link_paid${i}`] = el[`source_link_paid${i}`];
                if (el[`source_link_paid${i}`]) {
                    formObj[`urlLinkPaid${i}`] = `#/${el[`source_link_paid${i}`]}`;
                } else {
                    const href = encodeURI(`#/form${el.form}/${this.curYear}/${el.year}/${el.data_type}/${el.gr}/${el.abp}/${el.prg}/${el.ppr}/false/${el.variant}/${el.spf}/${el.bin}/gkkp/true/end/paid`)
                    formObj[`urlLinkPaid${i}`] = href;
                }
            }
        }
    }


    private getValue(obj: any) {
        obj[`value${(obj.year - this.curYear + 1)}`] = obj.value;
        obj[`valPaid${(obj.year - this.curYear + 1)}`] = obj.val_paid;
        obj[`source_link${(obj.year - this.curYear + 1)}`] = obj.value_source_link;
        obj[`source_link_paid${(obj.year - this.curYear + 1)}`] = obj.value_source_link_paid;
        delete obj.value_source_link;
        delete obj.value;
        delete obj.value_source_link_paid;
        delete obj.val_paid;
    }
    // --------------------------------------------------

    private async loadTotalGkkpPaid(params: any) {
        let result = [];
        try {
            const response: any = await fetch(`/api-py/get-budget-request-form-total-gkkp-paid/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
                if (result.status !== 'success') {
                    const typeErr = (result.status === 'warning') ? 'warning': 'danger';
                    makeToast(this, typeErr, 'get-budget-request-form-total-gkkp-paid', `${result.statusText}`);
                    return null;
                }
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-request-form-total-gkkp-paid', `${response.status} ${response.statusText}`);
                this.progress = 0;
                return null;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-request-form-total-gkkp-paid', (error as Error).toString());
            this.progress = 0;
            return null;
        }
        this.progress += 25;
        return result.data;
    }


    private async loadTotalAgreement() {
        if (!this.operationCode.length) { await this.loadOperations(); }
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = JSON.stringify({ curYear: parseInt(this.curYear.toString()), abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, mode_code: this.modeCode, operation_code: this.operationCode, sign_operation_code: this.operationSignCode, bin: this.curGkkp? this.curGkkp.bin: null, subord: this.curSubord, usrId: this.usrId, date_b: this.curVariant.date_start, date_e: this.variantEndDate, vers_year: versYear });
        let result = null;
        try {
            const response: any = await fetch(`/api-py/get-budget-total-agreement-gkkp/${encodeURI(params)}`);
            if (response.status === 200) {
                result = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-total-agreement-gkkp', `${response.status} - ${response.statusText}`);
                this.progress = 0;
                return new Map();
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-total-agreement-gkkp', (error as Error).toString());
            this.progress = 0;
            return new Map();
        }
        //
        this.progress+=10;
        return this.createTreeMap(result);
    }

    private createTreeMap(arr: any[]) {
        const resMap = new Map();
        if (!arr.length) { return resMap; }
        for (const el of arr) {
            let tmp = resMap.get(el.bin);
            if (tmp) {
                tmp.push(el);
            } else {
                tmp = [el];
            }
            resMap.set(el.bin, tmp);
        }
        for (const [keyRes, valueRes] of resMap) {
            const progMap = new Map();
            for (const el of valueRes) {
                let tmp = progMap.get(el.prg);
                if (tmp) {
                    tmp.push(el);
                } else {
                    tmp = [el];
                }
                progMap.set(el.prg, tmp);
            }
            for (const [key, value] of progMap) {
                const subProg = new Map();
                for (const el of value) {
                    let tmp = subProg.get(el.ppr);
                    if (tmp) {
                        tmp.push(el);
                    } else {
                        tmp = [el];
                    }
                    subProg.set(el.ppr, tmp);
                }
                for (const [keySub, valSub] of subProg) {
                    const spfMap = new Map();
                    if (valSub.length > 0) { subProg.set(keySub, valSub[0]); }
                }
                progMap.set(key, subProg);
            }
            resMap.set(keyRes, progMap);
        }
        return resMap;
    }


    private async loadOperations() {
        this.operationCode = [];
        if (this.usrId === null) { return; }
        let result = null;
        try {
            result = await fetch(encodeURI(`/api/um/module/link?user=${this.usrId}&modulecode=004.002.002.003`));
            if (result.status === 200) {
                result = await result.json();
            }  else {
                if (result.status !== 404) { makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', `${result.status}  ${result.statusText}`); }
                return;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', (error as Error).toString());
            return;
        }
        if (result.operations) {
            for (const el of result.operations) {
                if (el.startsWith('ecp_')) {
                    this.operationSignCode.push(el);
                } else {
                    this.operationCode.push(el);
                }
            }
        }
        this.$emit('chgAgrAccess', this.operationCode.length > 0);
    }

    private clkCollapse(calcIndx: number | null, progIndx: number | null, subIndx: number | null, spfIndx: number | null, collapse?: boolean) {
        if (calcIndx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.calcData) {
                el.collapse = this.collapseAll;
                for (const progEl of el.prgLst) {
                    if (progEl.collapse!==undefined) { progEl.collapse = this.collapseAll; }
                    for (const subEl of progEl.pprLst) {
                        subEl.collapse = this.collapseAll;
                    }
                }
            }
            return;
        }
        if (progIndx === null) {
            this.calcData[calcIndx].collapse = collapse;
            for (const el of this.calcData[calcIndx].prgLst) {
                if (el.collapse!==undefined) { el.collapse = collapse; }
            }
        } else {
            if (subIndx === null) {
                if (this.calcData[calcIndx].prgLst[progIndx].collapse!==undefined) { this.calcData[calcIndx].prgLst[progIndx].collapse = collapse; }
                for (const el of this.calcData[calcIndx].prgLst[progIndx].pprLst) {
                    el.collapse = collapse;
                }
            } else {
                if (spfIndx === null) {
                    this.calcData[calcIndx].prgLst[progIndx].pprLst[subIndx].collapse = collapse;
                } else {
                    this.calcData[calcIndx].prgLst[progIndx].pprLst[subIndx].spfLst[spfIndx].collapse = collapse;
                }
            }
        }
    }

    private setAgrEnabled() {
        if (this.curVariant && this.curVariant.attribute && !this.curVariant.status) {
            this.agrEnabled = true;
        } else {
            this.agrEnabled = false;
        }
    }

    // -------------- checked -------------------------------------------
    private clkCheck(calcIndx: number | null, progIndx: number | null, subIndx: number | null) {
        if (calcIndx === null) {
            for (const el of this.calcData) {
                if (el.checked !== undefined) {
                    el.checked = this.checkedAll;
                    this.checkAllChilds(this.checkedAll, el);
                 }
            }
            return;
        }
        let checked = this.calcData[calcIndx].checked;
        if (progIndx === null) {
            this.checkAllChilds(checked, this.calcData[calcIndx]);
        } else {
            if (subIndx === null) {
                checked = this.calcData[calcIndx].prgLst[progIndx].checked;
                this.checkAllChilds(checked, this.calcData[calcIndx].prgLst[progIndx]);
                if (!checked) {
                    this.calcData[calcIndx].checked = false;
                } else {
                    let fl = true;
                    for (let i =0; i < this.calcData[calcIndx].prgLst.length; i++) {
                        const el = this.calcData[calcIndx].prgLst[i];
                        if (el.checked === false) {
                            fl = false;
                            break;
                        }
                    }
                    this.calcData[calcIndx].checked = fl;
                }
            } else {
                checked =this.calcData[calcIndx].prgLst[progIndx].pprLst[subIndx];
                if (!checked) {
                    this.calcData[calcIndx].prgLst[progIndx].checked = false;
                } else {
                    let fl = true;
                    for (let i =0; i < this.calcData[calcIndx].prgLst[progIndx].pprLst.length; i++) {
                        const el = this.calcData[calcIndx].prgLst[progIndx].pprLst[i];
                        if (el.checked === false) {
                            fl = false;
                            break;
                        }
                    }
                    this.calcData[calcIndx].prgLst[progIndx].checked = fl;
                }
                if (!this.calcData[calcIndx].prgLst[progIndx].checked) {
                    this.calcData[calcIndx].checked = false;
                } else {
                    let fl = true;
                    for (let i =0; i < this.calcData[calcIndx].prgLst.length; i++) {
                        const el = this.calcData[calcIndx].prgLst[i];
                        if (el.checked === false) {
                            fl = false;
                            break;
                        }
                    }
                    this.calcData[calcIndx].checked = fl;
                }
            }
        }

        for (const el of this.calcData) {
            if (el.checked === false) {
                this.checkedAll = false;
                return;
            }
        }
        this.checkedAll = true;

    }

    // checked проставить для дочерних
    private checkAllChilds(checked: boolean, obj: any) {
        let fieldName: string | null = null;
        if ('prgLst' in obj) {
            fieldName = 'prgLst';
        } else if ('pprLst' in obj) {
            fieldName = 'pprLst';
        }
        if (fieldName === null) { return; }
            for (const el of obj[fieldName]) {
                if (el.checked!==undefined) {
                    el.checked = checked;
                    this.checkAllChilds(checked, el);
                }
            }
    }
    // ------------------- end checked ----------------------

    // -------------------- agreement ----------------------
    private async agreementEvent() {
        const selectArr: any = [];
        this.selectArr = [];
        this.agrBtnLst = { back: [], forward: [] };
        let firstStatus: number | null = null;
        const notSameStatus = this.getBudgetText('other.notSameStatus'); // Выберите подпрограммы с одинаковым статусом
        const title = this.getBudgetText('other.no_program[0]'); // Согласование
        for (const calc of this.calcData) {
            for (const prog of calc.prgLst) {
                if (prog.pprLst.length && prog.pprLst[0].ppr === null && prog.checked) { // без подпрограммы
                        if (firstStatus === null) { firstStatus = prog.agrObj.status; }
                        if (firstStatus !== prog.agrObj.status) {
                            makeToast(this, 'danger', title, `${notSameStatus}!`);
                            return;
                        }
                        selectArr.push({ consExp: {curYear: this.curYear, region: this.curRegion.code, dataType: this.curDataType.code, variant: this.curVariant.variant_uuid, abp: this.curAbp.abp, bin: calc.bin, prg: prog.prg, ppr: null}, agrObj: prog.agrObj });
                } else {
                    for (const sub of prog.pprLst) {
                        if (sub.checked && sub.spfLst.length && sub.agrObj) {
                            if (firstStatus === null) { firstStatus = sub.agrObj.status; }
                            if (firstStatus !== sub.agrObj.status) {
                                makeToast(this, 'danger', title, `${notSameStatus}!`);
                                return;
                            }
                            selectArr.push({ consExp: {curYear: this.curYear, region: this.curRegion.code, dataType: this.curDataType.code, variant: this.curVariant.variant_uuid, abp: this.curAbp.abp, bin: calc.bin, prg: prog.prg, ppr: sub.ppr}, agrObj: sub.agrObj })
                        }
                    }
                }

            }
        }
        if (selectArr.length === 0) {
            const nonSelected = this.getBudgetText('other.no_program[1]'); // Не выбрано ни одной программы/подпрограммы
            makeToast(this, 'warning', title, nonSelected);
            return;
        }

        this.selectArr = selectArr;

        // ---------------
        const params = { modeCode: this.modeCode, operationCode: this.operationCode, agrCode: firstStatus };

        let result: any = null;
        try {
            const response: any = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
            result = await response.json();
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-agreement-step-next-back', (error as Error).toString());
            this.progress = 0;
            return;
        }
        if (result.length === 0) {
            makeToast(this, 'warning', getBudgetText('toast.agreement'), getBudgetText('toast.no_agr_steps'));
            return;
        }
        for (const el of result) {
            let name = el[`name_${this.$i18n.locale}`];
            if (!name) { name = el.name_ru; }
            el.name = name;
            if (el.stepType === 1) {
                this.agrBtnLst.back.push(el);
            } else {
                this.agrBtnLst.forward.push(el);
            }
        }
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAgrModal.showEvent();
    }

    private async agrClk(data: any) {
        data.userId = store.state.user.sub;
        const saveArr = [];
        for (const el of this.selectArr) {
            saveArr.push(Object.assign({ id: el.agrObj.id, prg: el.consExp.prg, ppr: el.consExp.ppr, bin: el.consExp.bin }, data));
        }
        const saveObj = {
            modeCode: this.modeCode,
            variant: this.curVariant.variant_uuid,
            abp: this.curAbp.abp,
            cur_year: this.curYear,
            data_type: this.curDataType.code,
            region: this.curRegion.code,
            userId: this.usrId,
            locale: this.$i18n.locale,
            items: saveArr,
        };
        let result: any = await fetch('/api-py/set-brft_gkkp-agreement-step_gu',
            {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
        if (result.status === 200) {
            result = await result.json();
            for (const res of result) {
                if (res.result === 'error') {
                    makeToast(this, 'danger', getBudgetText('toast.save_status'), `${res.errTxt}`);
                    console.error('Ошибка set_brft_agreement_step_gu', res);
                    return;
                }
            }
            this.loadData();
        } else {
            makeToast(this, 'danger', getBudgetText('toast.save_status'), getBudgetText('toast.error_code_text', [result.status, result.statusText]));
            return;
        }
    }

    private commentClk(calcIndx: number, progIndx: number, subIndx: number | null) {
        let agrObj: any = null;
        if (subIndx!==null) {
            agrObj = this.calcData[calcIndx].prgLst[progIndx].pprLst[subIndx].agrObj;
        } else {
            agrObj = this.calcData[calcIndx].prgLst[progIndx].agrObj;
        }
        agrObj = JSON.parse(JSON.stringify(agrObj));
        agrObj.mode_code = 'gkkp';
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refHistModal.showEvent(agrObj);
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get tblTitle() {
        const obj = {
            gkkp: this.getBudgetText('filter.uploadType.val1'), //  ГККП
            prg: this.getBudgetText('sum_calc_abp.prg'), //  Программа
            ppr: this.getBudgetText('sum_calc_abp.ppr'), //  Подпрограмма
            spec: this.getBudgetText('sum_calc_abp.spec'), //  Специфика
            form: this.getBudgetText('sum_calc_gkkp.form'), //  Форма
            dataBZ: this.getBudgetText('sum_calc_abp.dataBZ'), //  Данные БЗ
            coment: this.getBudgetText('sum_calc_abp.coment'), // Комментарии
            sum_spend: this.getBudgetText('sum_calc_gkkp.sum_spend'), // Сумма расходов
            paid_service: this.getBudgetText('sum_calc_gkkp.paid_service'), // Платные услуги
            total: this.getBudgetText('sum_calc_gkkp.total'), //  Всего
            status: this.getBudgetText('sum_calc_gkkp.status') //  Статус
        }
        return obj;
    }
}
